function DeliveryTypeColumnFilter({ column: { setFilter, filterValue } }) {
  const handleOnChange = (event) => {
    setFilter(event.target.value || "");
  };

  return (
    <select
      value={filterValue || ""}
      className="form-control form-control-sm order-history-table-filters"
      onChange={handleOnChange}
    >
      <option value="">All</option>
      <option value="regular">Regular</option>
      <option value="return">Return</option>
      <option value="buy out">Buy Out</option>
    </select>
  );
}
export default DeliveryTypeColumnFilter;
